import { useRef } from 'react';
import { ScrollToProps } from './ScrollTo.types';
import { useScrollTo } from '../../../helpers/useScrollTo';

/**
 * Creates a wrapper container and scrolls to the dom node when scroll is true.
 * @param options - {@link ScrollToProps.options options} description.
 * @param scroll - {@link ScrollToProps.scroll scroll} description.
 * @param children - {@link ScrollToProps.children children} description.
 */
export const ScrollTo = ({
    options,
    scroll,
    children,
}: ScrollToProps) => {
    const ref = useRef<HTMLDivElement>(null);

    useScrollTo({
        scrollable: ref,
        options: options,
        scroll: scroll,
    });

    return (
        <div
            role={'presentation'}
            ref={ref}
            className={'scrollTo'}
        >
            {children}
        </div>
    );
};
